import { render, staticRenderFns } from "./pipe-newsletter-confirm.vue?vue&type=template&id=e4a7ff5a&scoped=true"
import script from "./pipe-newsletter-confirm.vue?vue&type=script&lang=js"
export * from "./pipe-newsletter-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a7ff5a",
  null
  
)

export default component.exports